import {ServiceConfigByCountryAndRole} from "../../../models/referential/service-config-by-country-and-role.model";
import {Page} from "../../../utils/page";
import {ServiceConfig} from "../../../models/referential/service-config.model";
import {ParametersDatabase} from "../../databases/parameters.database";

export class SqliteServiceConfigRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {}

    async getServiceConfigsByRoleCodeAndCountryIsoCode(roleCode: string, countryIsoCode: string): Promise<ServiceConfig[]> {
        const serviceConfigsByCountyAndRole: ServiceConfigByCountryAndRole[] = await this.parametersDatabase.queryObjects<ServiceConfigByCountryAndRole>(
            `SELECT *
         FROM countryroleserviceconfig`,
            null,
            ['serviceConfigs']
        );

        return serviceConfigsByCountyAndRole[0].serviceConfigs.map(serviceConfig => ({
            ...serviceConfig,
            isEnabled: typeof serviceConfig.isEnabled === "string" ? serviceConfig.isEnabled === "1" : serviceConfig.isEnabled
        }));
    }

    async getPagedServiceConfigsByCountryIsoCode(): Promise<Page<ServiceConfigByCountryAndRole>> {
        const page = 0;
        const size = 20;

        const pagedDocs: ServiceConfigByCountryAndRole[] = await this.parametersDatabase.queryObjects<ServiceConfigByCountryAndRole>(
            `SELECT *
         FROM countryroleserviceconfig
         LIMIT ${size} OFFSET ${page * size}`,
            null,
            ['serviceConfigs']
        );

        const totalDocumentsCount: number = await this.parametersDatabase.count(
            `SELECT count(*)
         FROM countryroleserviceconfig`
        );

        const content = pagedDocs.map(doc => ({
            ...doc,
            serviceConfigs: doc.serviceConfigs.map(serviceConfig => ({
                ...serviceConfig,
                isEnabled: typeof serviceConfig.isEnabled === "string" ? serviceConfig.isEnabled === "1" : serviceConfig.isEnabled // Conversion conditionnelle
            }))
        }));

        return {
            totalElements: totalDocumentsCount,
            totalPages: Math.ceil(totalDocumentsCount / size),
            first: page === 0,
            last: (page + 1) * size >= totalDocumentsCount,
            size: size,
            content: content,
            number: page,
            numberOfElements: pagedDocs.length,
            empty: pagedDocs.length === 0
        };
    }

}
